import { skillsUsed } from "@utils/constants";
import { SkillInput } from "@pages/SearchPage/DetailPage";
import { ChevronDown } from "lucide-react";
import { useState } from "react";

const dummySkills = [
  {
    title: "Incident response",
    importance: "Critical",
    requiredLevel: "Advanced",
    experience: "5+ years",
    recency: "Current",
    roleContext: "How this skill will be used",
    howSkillsIsUsed:
      "Applicants should show evidence of coordinating security incidents, working under pressure and turning incident learning into stronger controls.",
  },
  {
    title: "Security governance",
    importance: "Critical",
    requiredLevel: "Advanced",
    experience: "5+ years",
    recency: "Current",
    roleContext: "How this skill will be used",
    howSkillsIsUsed:
      "Applicants should show evidence of coordinating security incidents, working under pressure and turning incident learning into stronger controls.",
  },
  {
    title: "Stakeholder communication",
    importance: "Critical",
    requiredLevel: "Advanced",
    experience: "5+ years",
    recency: "Current",
    roleContext: "How this skill will be used",
    howSkillsIsUsed:
      "Applicants should show evidence of coordinating security incidents, working under pressure and turning incident learning into stronger controls.",
  },
];

const SkillCard = ({ skill }) => {
  const [expandSkillUsed, setExpandSkillUsed] = useState(false);

  return (
    <div className="rounded-md border-l-[3px] border-r border-y border-l-slate-600 overflow-hidden">
      <div className="text-lg font-bold px-4 py-3 text-black">
        {skill?.title}
      </div>

      <div className="grid grid-cols-[0.9fr_0.9fr_0.9fr_0.9fr_1.4fr] items-center border-t h-16">
        <div className="flex flex-col flex-1 gap-1.5 pl-4">
          <span className="font-semibold text-xss tracking-wider uppercase text-light-black">
            Importance
          </span>
          <span className="text-xs font-bold text-black">
            {skill?.importance}
          </span>
        </div>

        <div className="flex flex-col flex-1 gap-1.5 border-l pl-4">
          <span className="font-semibold text-xss tracking-wider uppercase text-light-black">
            Required Level
          </span>
          <span className="text-xs font-bold text-black">
            {skill?.requiredLevel}
          </span>
        </div>

        <div className="flex flex-col flex-1 gap-1.5 border-l pl-4">
          <span className="font-semibold text-xss tracking-wider uppercase text-light-black">
            Experience
          </span>
          <span className="text-xs font-bold text-black">
            {skill?.experience}
          </span>
        </div>

        <div className="flex flex-col flex-1 gap-1.5 border-l pl-4">
          <span className="font-semibold text-xss tracking-wider uppercase text-light-black">
            Recency
          </span>
          <span className="text-xs font-bold text-black">{skill?.recency}</span>
        </div>

        <button
          onClick={() => setExpandSkillUsed((prev) => !prev)}
          aria-expanded={expandSkillUsed}
          className="flex justify-between items-center flex-1 h-full gap-1.5 border-l px-4 bg-slate-100 hover:bg-slate-100"
        >
          <div className="flex flex-col gap-1.5">
            <span className="font-semibold text-xss tracking-wider uppercase text-light-black text-left">
              Role Context
            </span>
            <span className="text-xs font-bold text-black text-left">
              How this skill will be used
            </span>
          </div>

          <div className="flex items-center justify-center w-7 h-7 rounded-full border bg-white shrink-0">
            <ChevronDown
              size={18}
              className={`transition-transform duration-200 ease-out ${
                expandSkillUsed ? "rotate-180" : "rotate-0"
              }`}
            />
          </div>
        </button>
      </div>

      {expandSkillUsed ? (
        <div className="flex flex-col gap-1 border-t p-4">
          <span className="font-bold text-xss text-light-black tracking-wider uppercase">
            How this skill is used in the role
          </span>
          <span className="text-xs font-medium text-charcoal leading-4">
            {skill?.howSkillsIsUsed}
          </span>
        </div>
      ) : null}
    </div>
  );
};

const SkillsAndExperience = ({ data }) => {
  return (
    <div className="flex flex-col flex-1 min-h-0 overflow-y-scroll no-scrollbar">
      <div className="flex flex-col gap-1 border-b pb-5">
        <span className="font-semibold text-md">
          Skills and experience requested from applicants
        </span>
        <span className="text-xs text-light-black font-medium">
          These requirements are shown to candidates and used by COMTRACKED to
          explain role alignment.
        </span>
      </div>

      {/* Skills list */}
      <div className="flex flex-col mt-4 gap-5">
        {dummySkills?.map((skill) => {
          return <SkillCard skill={skill} />;
        })}
      </div>
    </div>
  );
};

export default SkillsAndExperience;
